import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';

import { ServicioValidacionCertificadosDigitales } from '../../../servicios/ServicioValidacionCertificadosDigitales';
import { ServicioArchivos } from '../../../servicios/ServicioArchivos';
import { ServicioObjetos } from '../../../servicios/ServicioObjetos';
import { ServicioHttp } from '../../../servicios/ServicioHttp';
import { getUsuario } from '../../../servicios/ServicioManejadorToken';

const PAGINACION_INICIAL = {
    registrosPorPagina: 20,
    numeroPagina: 0,
    restriccionesDinamicas: [],
    datos: []
};

export const Emisor = () => {
    const [emisor, setEmisor] = useState({});
    const [errores, setErrores] = useState({});
    const [usuario, setUsuario] = useState({});
    const toast = useRef(null);
    const [modalEmisor, setModalEmisor] = useState(false);
    const [entidades, setEntidades] = useState([]);
    const [regimenFiscales, setRegimenFiscales] = useState([]);

    const [paginacion, setPaginacion] = useState(PAGINACION_INICIAL);

    useEffect(() => {
        // declare the data fetching function
       
        consultarUsuarioSession();
       // consultarRegimenFiscal();
        paginar();
       
        

    }, [])

    const consultarUsuarioSession=()=>{
        ServicioHttp.consumirPostHttp('usuario/obtner.json').then(response => {
            console.log(response.data.objeto);
           setUsuario(response.data.objeto);
        
         
        }).catch(error => {
            console.log(error);
        });
    }

    const consultarRegimenFiscal = () =>{
        

        ServicioHttp.consumirPostHttp('regimen/registro_obtener_por_usocfdi_rfc.json',{rfc:emisor.rfc}).then(response => {
            console.log(response.data.objeto);
            setRegimenFiscales(response.data);
        
         
        }).catch(error => {
            console.log(error);
        });

    }

    const consultarRegimenFiscalEditar = (rfc) =>{
        

        ServicioHttp.consumirPostHttp('regimen/registro_obtener_por_usocfdi_rfc.json',{rfc:rfc}).then(response => {
            console.log(response.data.objeto);
            setRegimenFiscales(response.data);
        
         
        }).catch(error => {
            console.log(error);
        });

    }

    const paginar = () => {
        console.log(usuario.usuario);
        ServicioHttp.consumirPostHttp('emisor/consulta.json', paginacion).then(response => {
            console.log("pedos");
            setPaginacion(response.data.objeto);
            console.log(paginacion);
            //paginarEntidad();
            toast.current.show({ severity:response.data.error === false ?
                "success" : "error", summary: '', detail: response.data.mensaje, life: 8000 });
        }).catch(error => {
            setPaginacion(paginacion);
            toast.current.show({ severity: 'error', summary: '', detail: "Error de conexion al servidor", life: 8000 });
        });
    }

    // const paginarEntidad = () => {
    //     const paginacion_entidad = {
    //         registrosPorPagina: 10000,
    //         numeroPagina: 0
    //     };
    //     ServicioHttp.consumirPostHttp('entidad/consulta.json', paginacion_entidad).then(response => {
    //         setEntidades(response.data.objeto.datos);
    //     }).catch(error => {
    //         setEntidades(paginacion_entidad);
    //         toast.current.show({ severity: 'error', summary: '', detail: "Error de conexion al servidor", life: 8000 });
    //     });
    // }

    const handleChange = e => {
        const { name, value } = e.target;
        let valorPropiedad = value;
        if (name !== "claveCsd" && name!=="lugarExpedicion"  && name!=="regimenFiscal")
            valorPropiedad = valorPropiedad.toUpperCase();
        setEmisor(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: valorPropiedad
        }));
    };


    const cerrarModal = () => {
        setModalEmisor(false);
        setErrores({});
        setEmisor({});
    }

    const nuevoModal = () => {
        setModalEmisor(true);
        setEmisor({});
        setErrores({});
    }

    const validarFormularioEmisor = () => {
        const errores = {};
        if (ServicioObjetos.esObjetoVacio(emisor.rfc))
            errores.rfc = "RFC es requerido";
        if (ServicioObjetos.esObjetoVacio(emisor.nombre))
            errores.nombre = "Nombre es requerido";
        if (ServicioObjetos.esObjetoVacio(emisor.csdCer))
            errores.csdCer = "CSD .cer es requerido";
        if (ServicioObjetos.esObjetoVacio(emisor.csdKey))
            errores.csdKey = "CSD .key es requerido";
        if (ServicioObjetos.esObjetoVacio(emisor.claveCsd))
            errores.claveCsd = "Clave CSD es requerida";
        if (ServicioObjetos.esObjetoVacio(emisor.direccion))
            errores.direccion = "Domicilio es requerido";
            if (ServicioObjetos.esObjetoVacio(emisor.lugarExpedicion))
            errores.lugarExpedicion = "Lugar Expedición es requerido";
        if(ServicioObjetos.esObjetoVacio(emisor.regimenFiscal))
        errores.regimenFiscal = "Clave Regimen Fiscal es requerido";
        return errores;
    }

    const guardarEmisor = () => {
        let erroresFrm = validarFormularioEmisor();
        setErrores(erroresFrm);
        if (ServicioObjetos.esObjetoVacio(erroresFrm)) {
            try {
                let certificado = ServicioValidacionCertificadosDigitales.validacionCertificadosDigitales(emisor.csdCer, emisor.csdKey, emisor.claveCsd, emisor.rfc, "CSD");
                let tcEmisor = {
                    id: emisor.id,
                    rfc: emisor.rfc,
                    nombre: emisor.nombre,
                    csdCer: emisor.csdCer,
                    csdKey: emisor.csdKey,
                    claveCsd: emisor.claveCsd,
                    domicilio: emisor.domicilio,
                    estado: 1,
                    noCertificado: certificado.numeroCertificado,
                    lugarExpedicion:emisor.lugarExpedicion,
                    direccion:emisor.direccion,
                    regimenFiscal:emisor.regimenFiscal.id
                };
                let url = "emisor/guadar.json";
                if (!ServicioObjetos.esObjetoVacio(tcEmisor.id))
                    url = "emisor/actualizar.json";

                ServicioHttp.consumirPostHttp(url, tcEmisor).then((response) => {
                    paginar();
                    cerrarModal();
                    toast.current.show({ severity: 'info', summary: 'Success', detail: 'Emisor guardado con éxito', life: 3000 });

                }).catch((error) => {
                    toast.current.show({ severity: 'error', summary: '', detail: error.response.data.mensaje, life: 3000 });
                });
            } catch (error) {
                toast.current.show({ severity: 'error', summary: '', detail: error.toString(), life: 3000 });
            }
        }
    }


    const basicDialogFooter = (
        <>
            <Button type="button" label="Cancelar" icon="pi pi-times" onClick={cerrarModal} className="p-button-text" />
            <Button type="button" label="Guardar" icon="pi pi-check" onClick={guardarEmisor} className="p-button-text" autoFocus />
        </>)

    const onUploadCer = (e) => {
        ServicioArchivos.obtenerBytesBase64StringArchivoPromise(e.files[0], emisor, 'csdCer').then(response => {
            toast.current.show({ severity: 'info', summary: 'Success', detail: 'Archivo CSD .cer cargado con éxito', life: 3000 });
        })


    }

    const onUploadcsdKey = (e) => {
        ServicioArchivos.obtenerBytesBase64StringArchivoPromise(e.files[0], emisor, 'csdKey').then(response => {
            toast.current.show({ severity: 'info', summary: 'Success', detail: 'Archivo CSD .key cargado con éxito', life: 3000 });
        })
    }

    const tipoEntidad = (e) => {
        let valor = entidades.find(objeto => objeto.id === e.idEntidad);
        return valor.descripcion;
    }

    const columnaEditar = (rowData) => {
        return (
            <div className="actions">
                <Button type="button" icon="pi pi-pencil" onClick={() => editarEmisor(rowData)} className="p-button-success" />
            </div>
        );
    }


    const editarEmisor = (objeto) => {
        setModalEmisor(true);
        setEmisor(objeto);
        consultarRegimenFiscalEditar(objeto.rfc);
    }
   const templateRegimen= (option) => {
        return (
          <div className="p-clearfix">
            <span >{option.clave} - {option.descripcion}</span>
          </div>
        );
      }


    return (
        <>
            <Toast ref={toast} />
            <Dialog header="Información del Emisor" visible={modalEmisor} modal footer={basicDialogFooter} onHide={cerrarModal}>

                <div className="grid">
                    <div className="card">
                        <h5>Los campos con (*) son obligatorios.</h5>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="rfc">* RFC</label>
                                <InputText id="rfc" type="text" name="rfc"
                                    value={emisor.rfc || ""}  onBlur={consultarRegimenFiscal} onChange={handleChange} className={errores.rfc ? "p-invalid" : ""} />
                                {errores.rfc ? <div><Message severity="error" text={errores.rfc} /></div> : null}
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="nombre">* Razón Social</label>
                                <InputText id="nombre" type="text" name="nombre"
                                    value={emisor.nombre || ""} onChange={handleChange} className={errores.nombre ? "p-invalid" : ""} />
                                {errores.nombre ? <div><Message severity="error" text={errores.nombre} /></div> : null}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="lugarExpedicion">* Lugar Expedición</label>
                                <InputText id="lugarExpedicion" name="lugarExpedicion" value={emisor.lugarExpedicion  || ""} onChange={handleChange} className={errores.lugarExpedicion ? "p-invalid" : ""}/>
                                {errores.lugarExpedicion ? <div><Message severity="error" text={errores.lugarExpedicion} /></div> : null}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="claveCsd">* Clave Csd</label>
                                <InputText id="claveCsd" type="text" name="claveCsd"
                                    value={emisor.claveCsd || ""} onChange={handleChange} className={errores.claveCsd ? "p-invalid" : ""} />
                                {errores.claveCsd ? <div><Message severity="error" text={errores.claveCsd} /></div> : null}
                            </div>

                            <div className="field col-12 md:col-3">
                                <label htmlFor="csdCer">* Archivo CSD .cer</label>
                                <FileUpload id="cer" mode="basic" name="demo[]" accept=".cer" onSelect={onUploadCer} auto chooseLabel="Archivo CSD .cer" className={errores.csdCer ? 'p-error' : ''} />
                                {errores.csdCer ? <div><Message severity="error" text={errores.csdCer} /></div> : null}
                            </div>
                            <div className="field col-12 md:col-3">
                                <label htmlFor="csdKey">* Archivo CSD .cer</label>
                                <FileUpload id="key" mode="basic" name="demo[]" accept=".key" onSelect={onUploadcsdKey} auto chooseLabel="Archivo CSD .key" className={errores.csdKey ? 'p-error' : ''} />
                                {errores.csdKey ? <div><Message severity="error" text={errores.csdKey} /></div> : null}
                            </div>
                            <div className="field col-12 md:col-12">
                                <label htmlFor="direccion">* Domicilio</label>
                                <InputText id="direccion" type="text" name="direccion"
                                    value={emisor.direccion || ""} onChange={handleChange} className={errores.direccion ? "p-invalid" : ""} />
                                {errores.direccion ? <div><Message severity="error" text={errores.direccion} /></div> : null}
                            </div>
                            <div className="field col-12 md:col-12">
                            <Dropdown dataKey="id" id="regimenFiscal" name="regimenFiscal" options={regimenFiscales} value={emisor.regimenFiscal} onChange={handleChange} itemTemplate={templateRegimen} optionLabel="descripcion" className={errores.regimenFiscal ? 'p-error' : ''} />
                            {errores.regimenFiscal ? <div><Message severity="error" text={errores.regimenFiscal} /></div> : null} 
                                </div>



                            
                               
                        
                        </div>
                    </div>

                </div>
            </Dialog>
            <div className="grid list-demo">
                <div className="col-12">
                    <div className="card p-fluid">
                        <h5>Administración de CSD</h5>
                         <Button type="button" label="Nuevo Emisor" icon="pi pi-lock" onClick={nuevoModal} /> 
                        <div className="grid table-demo">
                            <div className="col-12">
                                <div className="card">
                                    <h5>Mis CSD</h5>
                                    <DataTable value={paginacion.datos} className="p-datatable-gridlines" showGridlines
                                        responsiveLayout="scroll">
                                        <Column field="rfc" header="Rfc" style={{ width: '50px' }} />
                                        <Column field="nombre" header="Nombre" style={{ width: '50px' }} />
                                        <Column field="direccion" header="Domicilio" style={{ width: '50px' }} />
                                      
                                        
                                        <Column body={columnaEditar} header="Editar" style={{ width: '50px' }} />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}